/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserIntercomLinkQueryVariables = GraphQL.Exact<{
  legacyUserId: GraphQL.Scalars['ID']['input'];
}>;


export type UserIntercomLinkQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly intercomLink: string | null, readonly legacyId: string } | null };


export const UserIntercomLinkDocument = gql`
    query UserIntercomLink($legacyUserId: ID!) {
  user(legacyId: $legacyUserId) {
    id
    intercomLink
    legacyId
  }
}
    `;

/**
 * __useUserIntercomLinkQuery__
 *
 * To run a query within a React component, call `useUserIntercomLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIntercomLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIntercomLinkQuery({
 *   variables: {
 *      legacyUserId: // value for 'legacyUserId'
 *   },
 * });
 */
export function useUserIntercomLinkQuery(baseOptions: Apollo.QueryHookOptions<UserIntercomLinkQuery, UserIntercomLinkQueryVariables> & ({ variables: UserIntercomLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserIntercomLinkQuery, UserIntercomLinkQueryVariables>(UserIntercomLinkDocument, options);
      }
export function useUserIntercomLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserIntercomLinkQuery, UserIntercomLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserIntercomLinkQuery, UserIntercomLinkQueryVariables>(UserIntercomLinkDocument, options);
        }
export function useUserIntercomLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserIntercomLinkQuery, UserIntercomLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserIntercomLinkQuery, UserIntercomLinkQueryVariables>(UserIntercomLinkDocument, options);
        }
export type UserIntercomLinkQueryHookResult = ReturnType<typeof useUserIntercomLinkQuery>;
export type UserIntercomLinkLazyQueryHookResult = ReturnType<typeof useUserIntercomLinkLazyQuery>;
export type UserIntercomLinkSuspenseQueryHookResult = ReturnType<typeof useUserIntercomLinkSuspenseQuery>;
export type UserIntercomLinkQueryResult = Apollo.QueryResult<UserIntercomLinkQuery, UserIntercomLinkQueryVariables>;